import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from './toast';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed top-4 right-4 z-[200] flex w-[calc(100vw-2rem)] max-w-sm flex-col gap-2 pointer-events-none sm:top-6 sm:right-6">
      @for (toast of toastService.messages(); track toast.id) {
        <button
          type="button"
          (click)="toastService.dismiss(toast.id)"
          class="pointer-events-auto flex w-full items-start gap-3 rounded-xl border bg-white px-4 py-3 text-left shadow-2xl transition-all animate-in slide-in-from-top-2 fade-in duration-200"
          [ngClass]="{
            'border-slate-200 text-slate-800': toast.type === 'info',
            'border-emerald-200 text-emerald-900': toast.type === 'success',
            'border-rose-200 text-rose-900': toast.type === 'error'
          }">
          <span
            class="mt-1 h-2.5 w-2.5 shrink-0 rounded-full"
            [ngClass]="{
              'bg-slate-700': toast.type === 'info',
              'bg-emerald-500': toast.type === 'success',
              'bg-rose-500': toast.type === 'error'
            }"></span>
          <span class="min-w-0 flex-1 text-sm font-semibold leading-snug">{{ toast.message }}</span>
          <span class="shrink-0 text-sm font-black text-slate-400">×</span>
        </button>
      }
    </div>
  `
})
export class ToastContainer {
  toastService = inject(ToastService);
}
